module.exports = __webpack_public_path__ + "media/images/promotions/cards/chance-1-6dc7adc63844f7a2d655deea1a0b9f48.svg";